import React from 'react';
import { ToolbarColors } from '../custom/ToolbarColors';
export const WToolbarColors = ({ className, editor, focus, onClick, }) => {
    const action = editor.actions.colorify;
    const currentColor = action.meta();
    return (React.createElement(ToolbarColors, { active: action.isActive(), enable: action.isEnable(), currentColor: currentColor, exec: (color) => {
            action.run({ color: color === currentColor ? '' : color });
        }, className: className, focus: focus, onClick: onClick, withDefault: true }));
};
